<template>
  <v-app>
    <v-snackbar
      v-model="snackbarState"
      :color="snackbarColor?snackbarColor:'success'"
      :timeout="4000"
      multi-line
      top
    >
      {{ snackbarMessage }}
      <v-btn
        dark
        text
        @click="snackbarState = false"
      >
        Ok
      </v-btn>
    </v-snackbar>
    <core-toolbar v-if="isLogged" />

    <core-drawer v-if="isLogged && $route.name !== 'home' && $route.name !== 'user-login'" />

    <core-view />
  </v-app>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('app', ['snackbarMessage', 'snackbarColor']),
    ...mapState('user', ['isLogged']),
    snackbarState: {
      set (value) {
        this.$store.state.app.snackbarState = value
      },
      get () {
        return this.$store.state.app.snackbarState
      }
    }
  }
}
</script>

<style lang="scss">
    @import '@/styles/index.scss';

    /* Remove in 1.2 */
    .v-datatable thead th.column.sortable i {
        vertical-align: unset;
    }

  .v-tooltip__content {
    background: #FFFFFF !important;
  }
</style>
